'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _ButtonToolbar = require('react-bootstrap/lib/ButtonToolbar');

var _ButtonToolbar2 = _interopRequireDefault(_ButtonToolbar);

var _Modal = require('react-bootstrap/lib/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _commonFormsy = require('../../../common-formsy');

var _CaseUpdateFormBody = require('./CaseUpdateFormBody');

var _CaseUpdateFormBody2 = _interopRequireDefault(_CaseUpdateFormBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var CaseUpdateModal = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(CaseUpdateModal, _Component);

  function CaseUpdateModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CaseUpdateModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CaseUpdateModal.__proto__ || Object.getPrototypeOf(CaseUpdateModal)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'isValid', _descriptor, _this), _initDefineProp(_this, 'isLoading', _descriptor2, _this), _initDefineProp(_this, 'data', _descriptor3, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CaseUpdateModal, [{
    key: 'setRefForm',
    value: function setRefForm(comp) {
      this.refForm = comp;
    }
  }, {
    key: 'onChange',
    value: function onChange(data) {
      this.data = Object.assign({}, this.data, data);
      this.isValid = !!this.data.tracking_status || !!this.data.body.trim();
    }
  }, {
    key: 'onValidSubmit',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _props, onCreate, _case, onClose;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.isLoading = true;
                _props = this.props, onCreate = _props.onCreate, _case = _props._case, onClose = _props.onClose;
                _context.next = 4;
                return onCreate(_case.id, (0, _mobx.toJS)(this.data));

              case 4:
                onClose();

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onValidSubmit() {
        return _ref2.apply(this, arguments);
      }

      return onValidSubmit;
    }()
  }, {
    key: 'onSubmitButtonClick',
    value: function onSubmitButtonClick() {
      this.refForm.submit();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          _case = _props2._case,
          onClose = _props2.onClose;


      return _react2.default.createElement(
        _Modal2.default,
        { className: 'modal-case-update', show: true, onHide: onClose },
        _react2.default.createElement(
          _Modal2.default.Header,
          { closeButton: true },
          _react2.default.createElement(
            _Modal2.default.Title,
            null,
            'Case Tracking Update'
          )
        ),
        _react2.default.createElement(
          _Modal2.default.Body,
          null,
          _react2.default.createElement(
            _commonFormsy.Form,
            { ref: this.setRefForm, onValidSubmit: this.onValidSubmit },
            _react2.default.createElement(_CaseUpdateFormBody2.default, {
              _case: _case,
              onChange: this.onChange
            })
          )
        ),
        _react2.default.createElement(
          _Modal2.default.Footer,
          null,
          _react2.default.createElement(
            _ButtonToolbar2.default,
            { className: 'pull-right' },
            _react2.default.createElement(
              _Button2.default,
              { onClick: onClose },
              'Cancel'
            ),
            _react2.default.createElement(
              _Button2.default,
              {
                className: 'btn-submit',
                onClick: this.onSubmitButtonClick,
                disabled: !this.isValid || this.isLoading,
                bsStyle: 'primary',
                type: 'submit'
              },
              this.isLoading ? 'Loading...' : 'Create'
            )
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return CaseUpdateModal;
}(_react.Component), _class3.propTypes = {
  _case: _propTypes2.default.object.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  onCreate: _propTypes2.default.func.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isValid', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'isLoading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'data', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'onChange', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onChange'), _class2.prototype)), _class2)) || _class) || _class;

var _default = CaseUpdateModal;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CaseUpdateModal, 'CaseUpdateModal', '/app/src/components/page-case/main-details/CaseUpdates/CaseUpdateModal.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-details/CaseUpdates/CaseUpdateModal.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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